export const years = [
  "--",
  new Date().getFullYear(),
  new Date().getFullYear() + 1,
]

export const months = [
  { value: 0, display: "--" },
  { value: 1, display: "1 - January" },
  { value: 2, display: "2 - February" },
  { value: 3, display: "3 - March" },
  { value: 4, display: "4 - April" },
  { value: 5, display: "5 - May" },
  { value: 6, display: "6 - June" },
  { value: 7, display: "7 - July" },
  { value: 8, display: "8 - August" },
  { value: 9, display: "9 - September" },
  { value: 10, display: "10 - October" },
  { value: 11, display: "11 - November" },
  { value: 12, display: "12 - December" },
]

export const days = ["--"].concat([...Array(31).keys()].map(x => ++x))

export const genders = [
  { value: "male", display: "Male" },
  { value: "female", display: "Female" },
  { value: "coed", display: "Coed" },
  { value: "sibling", display: "Sibling" },
]

export const states = [
  { name: "Alabama", abbr: "AL" },
  { name: "Alaska", abbr: "AK" },
  { name: "Arizona", abbr: "AZ" },
  { name: "Arkansas", abbr: "AR" },
  { name: "California", abbr: "CA" },
  { name: "Colorado", abbr: "CO" },
  { name: "Connecticut", abbr: "CT" },
  { name: "Delaware", abbr: "DE" },
  { name: "Florida", abbr: "FL" },
  { name: "Georgia", abbr: "GA" },
  { name: "Hawaii", abbr: "HI" },
  { name: "Idaho", abbr: "ID" },
  { name: "Illinois", abbr: "IL" },
  { name: "Indiana", abbr: "IN" },
  { name: "Iowa", abbr: "IO" },
  { name: "Kansas", abbr: "KS" },
  { name: "Kentucky", abbr: "KY" },
  { name: "Louisiana", abbr: "LA" },
  { name: "Maine", abbr: "ME" },
  { name: "Maryland", abbr: "MD" },
  { name: "Massachusetts", abbr: "MA" },
  { name: "Michigan", abbr: "MI" },
  { name: "Minnesota", abbr: "MN" },
  { name: "Mississippi", abbr: "MS" },
  { name: "Missouri", abbr: "MO" },
  { name: "Montana", abbr: "MT" },
  { name: "Nebraska", abbr: "NE" },
  { name: "Nevada", abbr: "NV" },
  { name: "New Hampshire", abbr: "NH" },
  { name: "New Jersey", abbr: "NJ" },
  { name: "New Mexico", abbr: "NM" },
  { name: "New York", abbr: "NY" },
  { name: "North Carolina", abbr: "NC" },
  { name: "North Dakota", abbr: "ND" },
  { name: "Ohio", abbr: "OH" },
  { name: "Oklahoma", abbr: "OK" },
  { name: "Oregon", abbr: "OR" },
  { name: "Pennsylvania", abbr: "PA" },
  { name: "Rhode Island", abbr: "RI" },
  { name: "South Carolina", abbr: "SC" },
  { name: "South Dakota", abbr: "SD" },
  { name: "Tennessee", abbr: "TN" },
  { name: "Texas", abbr: "TX" },
  { name: "Utah", abbr: "UT" },
  { name: "Vermont", abbr: "VT" },
  { name: "Virginia", abbr: "VA" },
  { name: "Washington", abbr: "WA" },
  { name: "West Virginia", abbr: "WV" },
  { name: "Wisconsin", abbr: "WI" },
  { name: "Wyoming", abbr: "WY" },
]

export const types = [
  { value: "camp_type_day", display: "Day Camp", isChecked: true },
  {
    value: "camp_type_sleep_away",
    display: "Sleep-away Camp",
    isChecked: true,
  },
]



// WEBPACK FOOTER //
// ./src/utils/camp-parameters.js